import { MediaLibraryModal } from "@/components/media/MediaLibraryModal";
import { Button } from "@/components/ui/button";
import { useState } from "react";

interface MediaFile {
  id: number;
  url: string;
  originalName: string;
  mimeType: string;
  size: number;
}

export const MediaDemoPage = () => {
  const [selected, setSelected] = useState<MediaFile | null>(null);

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-2xl font-bold">Media Library Demo</h1>
      <div className="flex items-center gap-4">
        <MediaLibraryModal 
          onSelect={setSelected} 
          trigger={<Button>Open Library</Button>}
        />
        {selected && <span className="text-green-600">File Selected!</span>}
      </div>
      
      {selected && (
        <div className="mt-4 border p-4 rounded bg-gray-50 dark:bg-zinc-800">
          <h2 className="font-bold mb-2">Selected File Details:</h2>
          <pre className="text-xs overflow-auto max-h-96">{JSON.stringify(selected, null, 2)}</pre>
          {selected.mimeType?.startsWith("image") && (
             <img src={selected.url} alt={selected.originalName} className="mt-2 max-w-sm rounded border" />
          )}
        </div>
      )}
    </div>
  );
};
